import { API_BASE_URL } from "../config/apiBase";
import { decryptToken } from "../Components/utils/getToken";

function authHeaders() {
  const token = decryptToken("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function fetchMyPermissions() {
  const res = await fetch(`${API_BASE_URL}/api/rbac/me/permissions`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load permissions");
  return data.data;
}

export async function fetchPermissionsGrouped() {
  const res = await fetch(`${API_BASE_URL}/api/rbac/permissions`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load permissions");
  return data.data;
}
